<template>
    <!--所有设备-->
    <div id="centreLeft1">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2">
                <span style="color:#5cd9e8">
                  <icon name="chart-pie"></icon>
                </span>
                <div class="d-flex">
                    <span class="fs-xl text mx-2">总设备数：{{chart1_data.total}}台  覆盖{{area_count.area1}}个省份 {{area_count.area2}}个城市</span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />
                </div>
            </div>
            <div style="display: grid;grid-template-columns: 6fr 6fr;">
                <div id="chart-pie1" style="width:3rem;height:2.2rem;"></div>
                <div style="margin: 0.2rem auto" v-if="cn" >
                    <div style="display: grid;grid-template-columns: 6fr 6fr;height:1.1rem;">
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    智能栓
                                </div>
                                <div class="num">
                                    {{modle_data.modle1}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    仓内主机
                                </div>
                                <div class="num">
                                    {{modle_data.modle2}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                    </div>
                    <div style="display: grid;grid-template-columns: 6fr 6fr;height:1.1rem;margin-top: 0.1rem;">
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    外接传感器
                                </div>
                                <div class="num">
                                    {{modle_data.modle3}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    子板
                                </div>
                                <div class="num">
                                    {{modle_data.modle4}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                    </div>
                </div>
                <div style="margin: 0.2rem auto" v-else>
                    <div style="display: grid;grid-template-columns: 6fr 6fr;height:1.1rem;">
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    普通型
                                </div>
                                <div class="num">
                                    {{modle_data.modle1}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    流量型
                                </div>
                                <div class="num">
                                    {{modle_data.modle2}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                    </div>
                    <div style="display: grid;grid-template-columns: 6fr 6fr;height:1.1rem;margin-top: 0.1rem;">
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    锁控型
                                </div>
                                <div class="num">
                                    {{modle_data.modle3}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    全能型
                                </div>
                                <div class="num">
                                    {{modle_data.modle4}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";
  export default {
    data() {
      return {
        chart: null
      };
    },
    mixins: [echartMixins],
    props: {
      chart1_data: {
        type: Object
      },
      area_count: {
        type: Object
      },
      modle_data: {
        type: Object
      },
      cn: {
        type: Number
      }
    },
    mounted() {
      this.draw();
    },
    methods: {
      draw() {
        // 基于准备好的dom，初始化echarts实例
        this.chart = this.$echarts.init(document.getElementById("chart-pie1"));

        let option = {
          title: {
            text: '总设备数:100',
            subtext: '纯属虚构',
            left: 'left',
            show: false
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: this.chart1_data.data,
            show: true,
            textStyle: {
              color: '#fff'
            }
          },
          series: [
            {
              name: '设备状态',
              type: 'pie',
              radius: '55%',
              center: ['70%', '60%'],
              data: this.chart1_data.series,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                normal: {
                  position: 'inner',
                  show : false
                }
              }
            }
          ]
        };


        this.chart.setOption(option);
      }
    },
    destroyed() {
      window.onresize = null;
    }
  };
</script>


<style lang="scss">
    #centreLeft1 {
        padding: 0.2rem;
        /*height: 5.125rem;*/
        min-width: 3.75rem;
        border-radius: 0.0625rem;
        .bg-color-black {
            /*height: 3.125rem;*/
            border-radius: 0.125rem;
        }
        .text {
            color: #c3cbde;
        }
        .chart-box {
            margin-top: 0.2rem;
            width: 2.125rem;
            height: 2.125rem;
            .active-ring-name {
                padding-top: 0.125rem;
            }
        }

        .bottom-data {
            .item-box {
                float: right;
                position: relative;
                width: 50%;
                color: #d3d6dd;
                // 金币
                .coin {
                    position: absolute;
                    left: 0.1rem;
                    top: 0.2125rem;
                    font-size: 0.25rem;
                    color: #ffc107;
                }
                .colorYellow {
                    color: yellowgreen;
                }
            }
        }
    }
    .head{
        margin: 0.2rem 0.1rem;
        text-align: center;
        font-size: 0.2rem;
        color: #E0FFFF;
    }
    .num{
        margin-top: 0.2rem;
        text-align: center;
        font-size: 0.25rem;
        font-weight: bold;
        color: #5cd9e8;
    }
    .border-box{
        margin-right: 0.1rem;
    }
</style>
